<template>
  <Transition name="fade">
    <div v-if="show" class="loader">
      <div class="whitespace-pre-line absolute inset-0 flex flex-col items-center justify-center transition-all duration-300 px-4 text-center">
        <img
          src="@/assets/images/loading.svg"
          alt="Carregando..."
        />
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
defineProps<{
  show: boolean
}>()
</script>

<style scoped>
.loader {
  width: 100%;
  height: 100%;
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.7);
}

.loader img {
  max-width: 85px;
  object-fit: contain;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
